export enum BookmarkCategory {
    Private = 'private',
    Group = 'enterprise',
    Public = 'public'
}
